<template>
  <div>
    <div class="ui grid container tratamentos">
      <div class="row">
        <h2 class="ui header">CONHEÇA OS NOSSOS
          <br>TRATAMENTOS ODONTOLÓGICOS
        </h2>
      </div>
      <div class="sixteen wide tablet four wide computer column">
        <div class="ui vertical secondary menu">
          <a
            class="item"
             v-if="item.tratamentoAtivo"
            v-for="(item,index) of tabs"
            :key="index"
            :class="{active:item._id == selected}"
            @click="selecionar(item._id)"
          >{{ item.titulo | truncate(30) }}</a>
        </div>
      </div>

      <div class="sixteen wide tablet twelve wide computer stretched column">
        <div class="ui basic segment">
          <div v-for="(page,index) of tabs" :key="index" v-show="page._id == selected">
            <h2 class="ui header">
              <div class="title">{{ page.titulo | truncate(70) }}</div>
              <!-- <div class="sub header">{{ page.titulo | truncate(20) }}</div> -->
            </h2>
            <div class="conteudo-html">     <img class="ui left floated image" :src="page.image" height="160">
            <p v-html="$options.filters.truncate(page.conteudo, 250)"></p></div>
       
    <router-link class="ui button basic mini" :to="{ name: 'tratamento', params: { id: page._id } }" >Saiba mais</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var VueTruncate = require("vue-truncate-filter");
import{json}  from "../assets/json.js";
export default {
  data() {
    return {
      tabs: "",
      selected: 'undefined'
    };
  },
  methods: {
    selecionar(valor) {
      this.selected = valor;
    }
  },
  created() {
    this.tabs = json;
    this.selected = this.tabs[1]._id;
  }
};
</script>

